(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("hu", [], factory);
	else if(typeof exports === 'object')
		exports["hu"] = factory();
	else
		root["$cbSelectPlusI18n"] = root["$cbSelectPlusI18n"] || {}, root["$cbSelectPlusI18n"]["hu"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 